export const featureList = [
  "CAD/Data Management",
  "Project Viewer",
  "BIM360 Docs",
  "Standard Designs",
  "Other",
];
